<div *ngIf="isLoading$ | async" class="loading">
  <mat-spinner color="accent" [diameter]="40"></mat-spinner>
</div>
